module.exports = __webpack_public_path__ + "img/mockup-domaine-de-lasnee.4a60124.jpg";